import { intersectionWith } from 'lodash';
import {
  CategoryOption,
  ComplexityOption,
  isCategoryOption,
  isComplexityOption,
  isPlaintextOption,
  SearchQuery,
  TextOption,
} from '../../../cookbook/SearchField/SearchField.helper';
import { inMemoryRecipes } from './inMemoryRecipes';

export const inMemoryFetchCookbookTransformations = (searchQuery: SearchQuery) => {
  const complexityOptions: ComplexityOption[] = searchQuery.filter(isComplexityOption);
  const complexityStrings = complexityOptions.map((option) => option.complexity);
  const matchingComplexityRecipes =
    complexityStrings.length === 0 ? inMemoryRecipes : inMemoryRecipes.filter((recipe) => complexityStrings.includes(recipe.complexity));

  const categoryOptions: CategoryOption[] = searchQuery.filter(isCategoryOption);
  const matchingCategoryRecipes =
    categoryOptions.length === 0
      ? matchingComplexityRecipes
      : matchingComplexityRecipes.filter(
          (recipe) =>
            intersectionWith(categoryOptions, recipe.categories, (searchCategory, recipeCategory) => searchCategory.category === recipeCategory.name)
              .length > 0
        );

  const textOptions: TextOption[] = searchQuery.filter(isPlaintextOption);
  const textOptionsStrings = textOptions.map((option) => option.text.toLowerCase());
  const matchingRecipes =
    textOptionsStrings.length === 0
      ? matchingCategoryRecipes
      : matchingCategoryRecipes.filter((recipe) =>
          textOptionsStrings.some((searchText) => recipe.title.toLowerCase().includes(searchText) || recipe.excerpt.toLowerCase().includes(searchText))
        );

  return {
    items: matchingRecipes,
    totalCount: matchingRecipes.length,
  };
};
